












import Vue from "vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Map from "@/components/Map/Map.vue";
import { mapMutations, mapState } from "vuex";
import {
  SET_LAYERS,
  SET_SURVEY_DATA,
  SET_LOADER,
  RootState
} from "./../store/types";
import axios from "axios";
export default Vue.extend({
  name: "Home",

  components: {
    Sidebar,
    Map,
    Loader: () => import("@/components/UI/Loader.vue")
  },

  computed: {
    ...mapState({
      isLoading: state => (state as RootState).loader,
      mapLoaded: state => (state as RootState).mapLoaded
    })
  },

  methods: {
    ...mapMutations({
      setLayers: SET_LAYERS,
      setSurveyData: SET_SURVEY_DATA,
      setLoader: SET_LOADER
    })
  },

  created() {
    this.setLoader(true);
  },

  async mounted() {
    const questionnaireSlug = this.$route.params.questionnaire || "";
    try {
      const res = await axios.get(questionnaireSlug, { timeout: 5000 });
      const data = res.data;

      const {
        id,
        title,
        subtitle,
        content,
        lines,
        questions,
        consentLabel,
        slug,
        disableFileUpload,
        disableUserInput,
        geoLoc,
        zoom
      } = data;

      document.title = title.replace("&nbsp;", " ");

      let layers
      if(lines){
        layers = lines.map(line => ({ ...line, isSelected: true }));
      }
      
      this.setSurveyData({
        layers,
        id,
        title,
        subtitle,
        content,
        questions,
        consentLabel,
        disableFileUpload,
        disableUserInput,
        geoLoc,
        zoom
      });

      if (!questionnaireSlug) {
        this.$router.push({
          name: "questionnaire",
          params: { questionnaire: slug },
          meta: { title }
        });
      }
    } catch (err) {
      this.$router.push({ name: "not-found" });
    }

    this.setLoader(false);
  }
});
